import {
  SegmentedControl,
  SegmentedControlItem,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@ideon-api/ideon-ui'

// Above this count the segments no longer fit on one row.
const MAX_SEGMENTS = 5

interface PermissionSetSelectorProps {
  permissionSets: ReadonlyArray<{ key: string }>
  value: string
  onChange: (key: string) => void
}

export function PermissionSetSelector({ permissionSets, value, onChange }: PermissionSetSelectorProps) {
  if (permissionSets.length > MAX_SEGMENTS) {
    return (
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger aria-label="Permission set" className="max-w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {permissionSets.map((set) => (
            <SelectItem key={set.key} value={set.key}>
              {set.key}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    )
  }

  return (
    <SegmentedControl
      aria-label="Permission set"
      value={value}
      onValueChange={onChange}
      className="max-w-full overflow-x-auto"
    >
      {permissionSets.map((set) => (
        <SegmentedControlItem key={set.key} value={set.key} title={set.key} className="max-w-48">
          <span className="truncate">{set.key}</span>
        </SegmentedControlItem>
      ))}
    </SegmentedControl>
  )
}
